import { useState } from "react";

import { Link } from "react-router-dom";

import { AGENTS } from "../../data/agents";

import VoiceFrontDeskSection from "./VoiceFrontDeskSection";

import Reveal from "./Reveal";

import LiquidGlassZone from "./LiquidGlassZone";

import LiquidGlassCard from "./LiquidGlassCard";



function shortAgentName(name) {
  return name.replace(" Agent", "");
}

function agentReadMoreHref(link) {
  if (link.startsWith("/")) return link;
  if (link.startsWith("#")) return `/${link}`;
  return link;
}

function hasReadMoreLink(link) {
  return link.startsWith("/") || (link.startsWith("#") && link !== "#agents");
}



export default function AgentOSLayer() {

  const [activeId, setActiveId] = useState(AGENTS[0].id);

  const active = AGENTS.find((a) => a.id === activeId) ?? AGENTS[0];



  return (

    <section id="agents" className="agent-os-section" aria-labelledby="agents-heading">

      <div className="wrap">

        <span className="kicker">AI Agent OS</span>

        <h2 className="section-title" id="agents-heading">

          Eight agents. <b>One connected chart.</b>

        </h2>

        <p className="section-lede">

          Click any agent to preview what it reads from the chart and what it drafts for your team.

          Every output stays in review — nothing goes to patients without sign-off.

        </p>



        <Reveal className="agent-os-panel-wrap">

          <LiquidGlassZone className="agent-os-panel-glass">

            <div className="agent-os-panel">

              <div className="agent-tabs-scroll" role="tablist" aria-label="AI agents">

                {AGENTS.map((agent) => {
                  const isActive = activeId === agent.id;
                  return (
                    <LiquidGlassCard
                      key={agent.id}
                      as="button"
                      type="button"
                      role="tab"
                      id={`agent-tab-${agent.id}`}
                      aria-selected={isActive}
                      aria-controls={`agent-panel-${agent.id}`}
                      className={`agent-tab-pill ${isActive ? "is-active" : ""} ${agent.accent ? "accent" : ""}`}
                      onClick={() => setActiveId(agent.id)}
                    >
                      <span className="agent-tab-name">{shortAgentName(agent.name)}</span>
                    </LiquidGlassCard>
                  );
                })}

              </div>



              <div

                className={`agent-detail ${active.accent ? "accent" : ""}`}

                id={`agent-panel-${active.id}`}

                role="tabpanel"

                aria-labelledby={`agent-tab-${active.id}`}

              >

                <h3>{active.name}</h3>

                <p className="agent-tagline">{active.tagline}</p>

                <p className="agent-desc">{active.description}</p>



                {active.id === "voice-receptionist" ? (

                  <VoiceFrontDeskSection variant="embed" showCta={false} />

                ) : (

                  <div className="agent-io-grid">

                    <div>

                      <h4>Reads from chart</h4>

                      <ul>

                        {active.inputs.map((item) => (

                          <li key={item}>{item}</li>

                        ))}

                      </ul>

                    </div>

                    <div>

                      <h4>Produces for review</h4>

                      <ul>

                        {active.outputs.map((item) => (

                          <li key={item}>{item}</li>

                        ))}

                      </ul>

                    </div>

                  </div>

                )}



                {active.id === "voice-receptionist" && (

                  <div className="agent-io-grid agent-io-grid--compact">

                    <div>

                      <h4>Reads from chart</h4>

                      <ul>

                        {active.inputs.map((item) => (

                          <li key={item}>{item}</li>

                        ))}

                      </ul>

                    </div>

                    <div>

                      <h4>Produces</h4>

                      <ul>

                        {active.outputs.map((item) => (

                          <li key={item}>{item}</li>

                        ))}

                      </ul>

                    </div>

                  </div>

                )}



                <div className="agent-detail-footer">
                  {hasReadMoreLink(active.link) ? (
                    <Link to={agentReadMoreHref(active.link)} className="btn-ghost agent-read-more">
                      Read more
                      <span className="ring" aria-hidden="true" />
                    </Link>
                  ) : (
                    <span className="agent-link-note">
                      Available inside your EMR chart — book a demo to see it live.
                    </span>
                  )}
                </div>

              </div>

            </div>

          </LiquidGlassZone>

        </Reveal>

      </div>

    </section>

  );

}

